import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  GameQuizEntity,
  PaginatedGameQuizzesResponse,
} from "../../services/gameQuiz/gameQuiz.types";

export type GameQuizState = {
  gameQuizzes: GameQuizEntity[];
  currentGameQuiz: GameQuizEntity | null;
  loading: boolean;
  loadingDetail: boolean;
  pagination: {
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
  };
};

const initialPagination = {
  total: 0,
  page: 1,
  pageSize: 10,
  totalPages: 0,
};

const initialState: GameQuizState = {
  gameQuizzes: [],
  currentGameQuiz: null,
  loading: false,
  loadingDetail: false,
  pagination: initialPagination,
};

const gameQuiz = createSlice({
  name: "gameQuiz",
  initialState,
  reducers: {
    clearGameQuiz: (state) => {
      state.gameQuizzes = [];
      state.currentGameQuiz = null;
      state.loading = false;
      state.loadingDetail = false;
      state.pagination = initialPagination;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setLoadingDetail: (state, action: PayloadAction<boolean>) => {
      state.loadingDetail = action.payload;
    },
    setGameQuizzesWithPagination: (
      state,
      action: PayloadAction<PaginatedGameQuizzesResponse>,
    ) => {
      state.gameQuizzes = action.payload.data;
      state.pagination = {
        total: action.payload.total,
        page: action.payload.page,
        pageSize: action.payload.pageSize,
        totalPages: action.payload.totalPages,
      };
      state.loading = false;
    },
    setCurrentGameQuiz: (
      state,
      action: PayloadAction<GameQuizEntity | null>,
    ) => {
      state.currentGameQuiz = action.payload;
      state.loadingDetail = false;
    },
    addGameQuiz: (state, action: PayloadAction<GameQuizEntity>) => {
      state.gameQuizzes.unshift(action.payload);
      state.pagination.total += 1;
    },
    updateGameQuiz: (
      state,
      action: PayloadAction<{ id: number; data: GameQuizEntity }>,
    ) => {
      const index = state.gameQuizzes.findIndex(
        (q) => q.id === action.payload.id,
      );
      if (index !== -1) {
        state.gameQuizzes[index] = action.payload.data;
      }
      if (state.currentGameQuiz?.id === action.payload.id) {
        state.currentGameQuiz = action.payload.data;
      }
    },
    deleteGameQuiz: (state, action: PayloadAction<number>) => {
      state.gameQuizzes = state.gameQuizzes.filter(
        (q) => q.id !== action.payload,
      );
      state.pagination.total = Math.max(0, state.pagination.total - 1);
    },
  },
});

export default gameQuiz;
export const {
  clearGameQuiz,
  setLoading,
  setLoadingDetail,
  setGameQuizzesWithPagination,
  setCurrentGameQuiz,
  addGameQuiz,
  updateGameQuiz,
  deleteGameQuiz,
} = gameQuiz.actions;
